export const paymentIntegrityConstants = {
  TITLE: 'Payment Integrity',
  SUBTITLE: '',

  CARDS: {
    CLAIMS: 'Claims',
    TOTAL_PAID: 'Opportunity Cost',
  },
  TABLE: '',
  ERROR: 'Error fetching categories',
  ERROR_CATEGORY: 'Error fetching category details',
};
